import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import TableHeaderHtmlCustom from '../../../../components/common/customTable/TableHeaderHtmlCustom';
import { TableCompHead } from '../../../../components/ui';
import { useQuery } from '../../../../hooks/UseQuery';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
};

const theadData = [
  [
    { text: 'SNO.' },
    { text: 'Employee`s Name.', style: { minWidth: '200px' } },
    { text: 'Payment Type', style: { minWidth: '200px' } },
    { text: 'Deptt', style: { minWidth: '200px' } },
    { text: 'Designation', style: { minWidth: '200px' } },
    { text: 'Tot', style: { minWidth: '80px' } },
    { text: 'Mobile', style: { minWidth: '80px' } },
    { text: 'Spl Allw', style: { minWidth: '80px' } },
    { text: 'W.Day', style: { minWidth: '80px' } },
    { text: 'P/Day', style: { minWidth: '80px' } },
    { text: 'L/Day', style: { minWidth: '80px' } },
    { text: 'Total', style: { minWidth: '80px' } },
    { text: 'Amount', style: { minWidth: '80px' } },
    { text: 'OT/HR S', style: { minWidth: '80px' } },
    { text: 'OT/HR', style: { minWidth: '80px' } },
    { text: 'OT/Amt', style: { minWidth: '80px' } },
    { text: 'Total', style: { minWidth: '80px' } },
    { text: 'PF', style: { minWidth: '80px' } },
    { text: 'ESIC', style: { minWidth: '80px' } },
    { text: 'Labour', style: { minWidth: '80px' } },
    { text: 'total', style: { minWidth: '80px' } },
    { text: 'Tea', style: { minWidth: '80px' } },
    { text: 'Adv', style: { minWidth: '80px' } },
    { text: 'PAYABLE', style: { minWidth: '80px' } },
    { text: 'CHEQUE PAYMENT', style: { minWidth: '80px' } },
    { text: 'CASH PAYABLE', style: { minWidth: '80px' } },
    { text: 'REMARKS', style: { minWidth: '200px' } },
  ],
];

const THead = ({ moduleData, isView }: IProps) => {
  const annual_date = useQuery('annual_date');

  return (
    <thead>
      <TableCompHead
        colSpan={27}
        rowSpan={1}
        labels={[]}
        values={[]}
        heading={`SALARY FOR THE MONTH OF ${annual_date}`}
      />

      <TableHeaderHtmlCustom tableHeaderObj={theadData} customStyle={style1} />
    </thead>
  );
};

export default THead;
